import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
const useBoolean = defaultValue => {
  const $ = _c(5);
  const [value, setValue] = useState(!!defaultValue);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setValue(true);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const onTrue = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setValue(false);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onFalse = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setValue(_temp);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const onToggle = t2;
  let t3;
  if ($[3] !== value) {
    t3 = {
      value,
      onTrue,
      onFalse,
      onToggle,
      setValue
    };
    $[3] = value;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export { useBoolean };
function _temp(prev) {
  return !prev;
}